<template>
  <div class="team">
    <div id="team" class="anchor"></div>
    <div class="enterprise-title" id="team">
      精英团队
      <lr-link :to="moreUrl" @click="reportClick('more', '330367')"
        >查看更多></lr-link
      >
    </div>
    <div class="team-content">
      <div class="team-card" v-for="(item, index) in team" :key="index">
        <div class="team-card-pic">
          <img :src="cardPic(item.img)" alt="" />
        </div>
        <div class="team-card-name">{{ item.name }}</div>
        <div class="team-card-content">
          {{ item.content }}
        </div>
        <div class="team-card-course">
          热门课程：<lr-link
            :to="item.courseUrl"
            @click="reportClick('elitecourse', item.courseId)"
            >{{ item.course }}</lr-link
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    team: {
      type: Array,
      default: () => [
        {
          name: '万涛',
          content:
            '长期深耕政企办公领域，软件应用实战经验丰富，曾为各级党政机关单位和百余家知名企业提供知识服务。严谨专业、幽默风趣、广受好评。',
          course: '一份高大上的汇报该怎么做？',
          courseUrl:
            'https://www.wps.cn/learning/article/simple/id/330357.html',
          img: 'wantao',
          courseId: '330357',
        }
      ],
    },
  },
  data() {
    return {
      moreUrl: 'https://www.wps.cn/learning/article/simple/id/330367.html',
    };
  },
  methods: {
    cardPic(img) {
      return require(`@/assets/image/enterprise/team/${img}.jpg`);
    },
    reportClick(click, type) {
      this.$collect.enterpriseHomepageClick({ click, area: 'elite', type });
    },
  },
};
</script>
<style lang="scss" scoped>
.team {
  &-content {
    display: flex;
    justify-content: space-between;
    user-select: none;
  }
  &-card {
    width: 262px;
    height: 305px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #e8e8e8;
    padding: 0 20px;
    &-pic {
      margin-top: 30px;
      text-align: center;
      > img {
        width: 90px;
        height: 90px;
        border-radius: 50%;
      }
    }
    &-name {
      margin-top: 12px;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #222226;
      line-height: 22px;
    }
    &-content {
      margin-top: 20px;
      height: 64px;
      font-size: 12px;
      font-weight: 400;
      color: #222226;
      line-height: 16px;
    }
    &-course {
      width: 100%;
      height: 33px;
      background: #f8f9fb;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #417ff9;
      line-height: 33px;
      user-select: none;
      text-align: left;
      margin-top: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      > a {
        width: 100%;
        color: #417ff9;
        text-decoration: underline;
        cursor: pointer;
        overflow: hidden;
      }
    }
  }
}
</style>
